<template>
  <div>
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs :crm_id="this.$route.params.crmid"/>
          <div
            class="evaluation-main"
            v-for="item in evaloneData"
            :key="item"
            v-if="isHistoryTemplate === 0">
            <el-row>
              <el-col :span="18">
                <div class="basic-title"><em>{{ item.teacherType }}：{{ item.teacherName }}</em></div>
              </el-col>
            </el-row>
            <div class="evaluation-wrap">
              <el-row class="evaluation-score">
                <el-col :span="6">
                  <label>专业度：</label>
                  <el-rate
                    v-model="item.professionalDegrees"
                    disabled
                    text-color="#ff9900"/>
                </el-col>
                <el-col :span="6">
                  <label>响应时间：</label>
                  <el-rate
                    v-model="item.responseTime"
                    disabled
                    text-color="#ff9900"/>
                </el-col>
                <el-col :span="6">
                  <label>服务态度：</label>
                  <el-rate
                    v-model="item.serviceAttitude"
                    disabled
                    text-color="#ff9900"/>
                </el-col>
              </el-row>
              <el-row class="evaluation-student">
                <el-col :span="24">学生评语：</el-col>
              </el-row>
              <el-row class="evaluation-content">
                <el-col :span="18">
                  {{ item.appraisalContent }}
                </el-col>
              </el-row>
            </div>
          </div>
          <el-row
            class="evaluation-button"
            v-if="isHistoryTemplate === 0">
            <el-col :span="18">
              <el-button
                type="primary"
                size="small"
                @click="handHistory(1)">查看历史记录</el-button>
            </el-col>
          </el-row>
          <div
            class="evaluation-main"
            v-if="isHistoryTemplate === 1"
            v-for="item in evaltwoData"
            :key="item"
          >
            <el-row class="evaluation-time">
              <el-col :span="18">
                <em>{{ item.praiseTime }}</em>
              </el-col>
            </el-row>
            <div
              v-for="itemSub in item.praiseData"
              :key="itemSub">
              <el-row>
                <el-col :span="18">
                  <div class="basic-title"><em>{{ itemSub.teacherType }}：{{ itemSub.teacherName }}</em></div>
                </el-col>
              </el-row>
              <div class="evaluation-wrap">
                <el-row class="evaluation-score">
                  <el-col :span="6">
                    <label>专业度：</label>
                    <el-rate
                      v-model="itemSub.professionalDegrees"
                      disabled
                      text-color="#ff9900"/>
                  </el-col>
                  <el-col :span="6">
                    <label>响应时间：</label>
                    <el-rate
                      v-model="itemSub.responseTime"
                      disabled
                      text-color="#ff9900"/>
                  </el-col>
                  <el-col :span="6">
                    <label>服务态度：</label>
                    <el-rate
                      v-model="itemSub.serviceAttitude"
                      disabled
                      text-color="#ff9900"/>
                  </el-col>
                </el-row>
                <el-row class="evaluation-student">
                  <el-col :span="24">学生评语：</el-col>
                </el-row>
                <el-row class="evaluation-content">
                  <el-col :span="18">
                    {{ itemSub.appraisalContent }}
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <el-row v-if="isHistoryTemplate === 1">
            <el-col :span="18">
              <div class="flip-area">
                <el-pagination
                  :current-page ="currentPage"
                  :page-size ="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="amount"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';

export default {
  data() {
    return {
      evaloneData: {}, // 一维数组
      evaltwoData: {}, // 二维数组
      isHistoryTemplate: 0, // 0 循环没有时间的一维数组， 1 循环有时间的二维数组
      loading: false,
      currentPage: 1,
      pageSize: 10,
      amount: null,
    };
  },
  computed: {
  },
  methods: {
    /**
     * Description: 学生详情-评价详情
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    getEval() {
      return new Promise((resolve) => {
        this.$http._get({
          url: `/index/Statistics/getPraiseDetail/crm_id/${this.$route.params.crmid}`,
        }).then(({ data }) => {
          resolve(data);
        });
      });
    },
    /**
     * Description: 查看历史记录接口
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    getEavlHistory(currentPage = this.currentPage, pageSize = this.pageSize, amount = this.amount) {
      this.loading = true;
      return this.$http._post({
        url: `/index/Statistics/getPraiseDetail/crm_id/${this.$route.params.crmid}/history/1`,
        data: {
          currentPage,
          pageSize,
          amount,
        },
      }).then(({ data }) => {
        this.isHistoryTemplate = 1;
        this.evaltwoData = data.data;
        this.amount = data.total;
        this.pageSize = data.per_page;
        this.loading = false;
      });
    },
    /**
     * Description: 查看历史记录
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    handHistory() {
      this.getEavlHistory();
    },
    /**
     * Description:  pageSize 改变时会触发
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    handleSizeChange(size) {
      this.getEavlHistory(this.currentPage, size);
    },
    /**
     * Description: currentPage 改变时会触发
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getEavlHistory(currentPage, this.pageSize);
    },
  },
  mounted() {
    this.getEval().then((data) => {
      this.evaloneData = data;
    });
  },
  components: {
    'jm-crumbs': crumbs,
  },
};
</script>

<style src="../../assets/css/fontFace.css"></style>

<style scoped>
  .flip-area{
    margin: 10px;
    text-align: right;
  }
  .evaluation-time{
    font-size: 16px;
    font-weight: bold;
  }
  .evaluation-time em {
    display: inline-block;
    margin: 5px 0 5px 0px;
    padding: 6px;
    border-bottom: 1px solid #b8c4ce;
    color: #5f5f5f;
  }
  .basic-title{
    cursor: inherit;
  }
  .evaluation-wrap {
    margin: 10px 8px 15px;
  }
  .evaluation-score label{
    margin-right: 5px;
    float: left;
  }
  .evaluation-content .el-col{
    margin: 15px 0;
    padding: 15px;
    border: 1px solid #7abbfd;
    background: #fafafa;
  }
  .evaluation-student {
    padding-top: 15px;
    font-size: 16px;
  }
  .evaluation-button{
    text-align: center;
  }
</style>
